import { render, staticRenderFns } from "./DealerField.vue?vue&type=template&id=1b9ad43d&"
import script from "./DealerField.vue?vue&type=script&lang=js&"
export * from "./DealerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports